import { apiGet, buildSearchParams, type SearchParamValue } from 'api/request'
import { OperationEnvironment } from 'types/operation'

/**
 * Build a URLSearchParams from a plain object, skipping empty/undefined values.
 * Thin wrapper over the shared {@link buildSearchParams} so operation hooks
 * stay on the single source of truth rather than a parallel implementation.
 */
export const opSearchParams = (params: Record<string, SearchParamValue>): URLSearchParams =>
  buildSearchParams(params)

/** Return a copy of `params` with the operation `environment` set. */
export const withEnv = (env: OperationEnvironment, params?: URLSearchParams): URLSearchParams => {
  const sp = new URLSearchParams(params)
  sp.set('environment', env)
  return sp
}

/** Typed GET against an operation endpoint, returning the response body. */
export const opGet = <T>(url: string, params?: URLSearchParams): Promise<T> =>
  apiGet<T>(url, params)
